export default {
    getCurrentPost(state) {
        return state.currentPost
    }
}